module.exports = __webpack_public_path__ + "static/img/Hualien-econstruction_01.d327587.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/Hualien-econstruction_01.jpg
// module id = RzNa
// module chunks = 98